import React, { useState } from 'react';
import classNames from 'classnames';
import { SectionProps } from '../../utils/SectionProps';
import ButtonGroup from '../elements/ButtonGroup';
import Button from '../elements/Button';
import Image from '../elements/Image';
import Modal from '../elements/Modal';
import { Link } from 'react-router-dom';

const propTypes = {
  ...SectionProps.types
}

const defaultProps = {
  ...SectionProps.defaults
}

const Hero = ({
  className,
  topOuterDivider,
  bottomOuterDivider,
  topDivider,
  bottomDivider,
  hasBgColor,
  invertColor,
  ...props
}) => {

  const [videoModalActive, setVideomodalactive] = useState(false);

  const openModal = (e) => {
    e.preventDefault();
    setVideomodalactive(true);
  }

  const closeModal = (e) => {
    e.preventDefault();
    setVideomodalactive(false);
  }   

  const outerClasses = classNames(
    'hero section center-content',
    topOuterDivider && 'has-top-divider',
    bottomOuterDivider && 'has-bottom-divider',
    hasBgColor && 'has-bg-color',
    invertColor && 'invert-color',
    className
  );

  const innerClasses = classNames(
    'hero-inner section-inner',
    topDivider && 'has-top-divider',
    bottomDivider && 'has-bottom-divider'
  );

  return (
    <section
      {...props}
      className={outerClasses}
    >
      <div className="container-sm">
        <div className={innerClasses}>
          <div className="hero-content">
            <div className="reveal-from-top mb-32 mt-0" data-reveal-delay="800">
              <ButtonGroup class="site-header-inner p-32 m-32">
                <a href="https://www.uclm.es/" className='p-16'>
                  <Image
                      src={require('./../../assets/images/uclm.svg')}
                      alt="UCLM"
                      width={170} />
                </a>
                <a href="https://www.jccm.es/" className='p-16'>
                  <Image
                      src={require('./../../assets/images/jccm.svg')}
                      alt="AEI"
                      width={170} />
                </a>
                <a href="https://ec.europa.eu/regional_policy/es/" className='p-16'>
                  <Image
                      src={require('./../../assets/images/feder.svg')}
                      alt="FEDER"
                      width={170} />
                </a>
              </ButtonGroup>
            </div>
            <h1 className="m-32 p-32 reveal-from-bottom" data-reveal-delay="200">
              <span className="text-color-primary">LOCA</span>: High performance cable-driven automated storage and retrieval system
            </h1>
            <div className="container-xs">
              <div className="reveal-from-bottom ta-l" data-reveal-delay="600">
                <p>Logistics is currently subject to a profound transformation connected to digitalization which aims at getting closer to the customer in order to reduce delivery times. While this is desirable in most retail channels, it is imperative for online sales of groceries.
                </p>
                <p>The research team already got results to overcome the main technical obstacles of cable driven robots seen in the scientific literature, reduced precision, and limited workspace. This proposal will be focused on the remaining problems that could possibly hinder the adoption of cable driven robots in logistics, especially regarding the balance between cost and productivity, safety and fault tolerance.
                </p>
                <p>This proposal develops robots that could turn online sales of groceries into a reality enhancing the profitability of <span className="text-color-high">micro fulfilment centres</span>, a key component in this market which is currently contributing losses to the balance sheet of online retailers.
                </p>
              </div>
            </div>
          </div>

{/*}
          <div className="hero-figure reveal-from-bottom illustration-element-01" data-reveal-value="20px" data-reveal-delay="800">
            <a
              data-video="https://player.vimeo.com/video/174002812"
              href="#0"
              aria-controls="video-modal"
              onClick={openModal}
            >
              <Image
                className="has-shadow"
                src={require('./../../assets/images/video-placeholder.jpg')}
                alt="Hero"
                width={896}
                height={504} />
            </a>
          </div>
          <Modal
            id="video-modal"
            show={videoModalActive}
            handleClose={closeModal}
            video="https://player.vimeo.com/video/174002812"
            videoTag="iframe" />
{*/}

        </div>        
      </div>
    </section>
  );
}

Hero.propTypes = propTypes;
Hero.defaultProps = defaultProps;

export default Hero;